import { useEffect, useRef, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import VendorCategoriesSelect from "../../components/common/inputs/VendorCategoriesSelect";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";

export default function VendorProductFilter({ filterDataHandler }) {
  const [categoryData, setCategoryData] = useState([]);

  const getCategory = async (params) => {
    const path = "admin/categories/withoutPaginate";
    try {
      const response = await getApi({ path, params: { ...params } });
      setCategoryData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategory({});
  }, []);

  const filterCategory = (data) => {
    filterDataHandler({ page: 1, categories: data });
  };

  const userModalRef = useRef();

  const [user, setUser] = useState(null);

  const deleteUser = () => {
    setUser(null);
    filterDataHandler({ page: 1, user: "" });
  };

  const handleUser = (data) => {
    setUser(data);
    filterDataHandler({ page: 1, user: data?._id });
  };

  return (
    <>
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
        <div className="admin-filter-grid">
          <div className="w-full min-w-0">
            <div class="max-w-md mx-auto">
              <label
                for="default-search"
                class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
              >
                Search
              </label>
              <div class="relative">
                <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                  <svg
                    class="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <input
                  onChange={(e) =>
                    filterDataHandler({ page: 1, name: e.target.value })
                  }
                  type="search"
                  className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="جست و جو محصول ..."
                  required
                />
              </div>
            </div>
          </div>
          <div className="w-full min-w-0">
            <VendorCategoriesSelect onChange={filterCategory} />
          </div>
          <div className="relative">
            <span
              onClick={() => userModalRef?.current?.showModal()}
              className="absolute w-full h-full"
            ></span>
            {user ? (
              <PiXFill
                className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
                onClick={deleteUser}
              />
            ) : null}
            <input
              value={user?.name || user?.mobile || "انتخاب کاربر"}
              disabled
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
        </div>
      </div>
    </>
  );
}
